<script>
    import {getMailtoUrl} from "../etc/helpers.js"
    import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}

### 會員和費用

#### 加入會員有什麼好處？

- 您可以使用所有的會員功能：讀經、玩卦、起卦、紀錄卦例、等等。
- 您可以隨時續訂，您還最多可以訂 3 年的長約：您可能會想：「這算哪門子的好處？」從我的角度來看，這個世界上會想學易經的人本就不多，願意花力氣練習的人就更少了。所以，我其實不知道會有多少人參加、也不知道會給自己帶來什麼麻煩。如果過了一陣子，我發現壞處大於好處，我就可以把付費功能移除，等所有會員到期後就收攤。不過，只要有付費會員，我就有義務繼續經營【XiYi 習易網】。所以，您要是覺得【XiYi 習易網】對您很有價值，您可以訂個 3 年長約，強迫我至少再經營 3 年。會員期中，如果會員年費漲價了，和您無關；如果年費降了，我會按照比例將您的剩餘期效延長，反正不會讓您吃虧。

#### 年費

先講好了，易經不好學，您要是用功學，應該就會感受到【XiYi
習易網】給您的幫助（省時省力），交點費用也就天經地義、順理成章了。還有，本站沒有月付會員制度，你如果還只是好奇、或是打算只學幾個月，那就先不要加入交年費。

##### 一般會員：年費 USD$60。

相當每個月 USD$5，就當作您每個月請我喝一杯星巴克大拿鐵吧。想想看，您一週花多少時間學習易經呢？您要是越用功、或是您的時間越寶貴，【XiYi
習易網】就能為您提供更大的價值。

##### 學生會員：3 年會費 USD$60。

只要您還是個是全職學生、生活所費仍然要靠父母提供，您可以繳交 USD$60，加入成為學生會員，換得 3 年在【XiYi
習易網】習易的環境。

成為學生會員的手續很簡單：先註冊。在訂購/增購付款流程裡，記得點選【學生會員】，
並且照實填寫您學校的相關資料，最後繳交 3 年的會費：USD$60。

如果您有特殊情況，手頭太緊，連 K 歌、看電影的錢都沒有，而又很想加入會員，
請點這個連結，<a href={getMailtoUrl()}>
完整填寫 email 表格後</a>，記得一定要把您的經濟情況寫一寫，再 email 給我。事情總是有解的。

##### 年費 USD$60 背後的道理

根據研究，想要學習、精通一門學問或是技藝，大概需要一萬個小時的投入。如果一天投入三個小時，十年後正好約一萬小時，
也許能有所成，「十年磨一劍」也就是如此。
習易通透需要多久呢？十年夠嗎？我不知道。不過，根據我自己的經驗，習易從初學到入門，很大一部分的時間和力氣都是花在把書本「翻來翻去」，一桌子的書
，翻到氣餒、翻到後面就忘了前面，等等。其實，這也就是我設計【XiYi
習易網】的基本動力 - 實在是翻得糊塗了！

假設一個還算用功的現代人，平均一天讀易、習易 30 分鐘，一個月共習易 15 小時，一年是 180 小時。【XiYi
習易網】能為您省時省力，不但不再需要經常「翻來翻去」，也不需要總是攤了一桌子的書，而且，隨時隨地用您的手機、平板都可以習易，這麼一來，
我相信【XiYi 習易網】至少能夠提升總體效率 30%。也就是一年為您節省了 60 個小時以上。

台灣現在最低工資時薪是台幣 160，或約 USD$5。即使您的收入是最低工資，【XiYi
習易網】一年也至少能為您節省 USD$300 或是 NT$9000。您的收入是最低工資嗎？您要是越用功、或是時間越寶貴，【XiYi
習易網】就能為您提供更大的價值。

如果您位是普通用功的人，每天平均只能花 10 分鐘讀易、學易，您的收入又是最低工資，
這樣的話，年費和省下的錢大概還是比打平好一點，您省了力氣，也提昇了的習易的效率，一樣很有好處。
不過，如果您要是平均一天真的只能最多花 10 分鐘學易，也許出門去散步、跑步 10 分鐘會對您更有益處！

為什麼用美元計價呢？因為我現在住在美國。如果將來搬家，我也許再改當地貨幣。還有，接下來，我還打算增加更多功能、改善 UI、等等。
隨著本站功能提昇和可能的通貨膨脹、貨幣貶值，所以，將來也會適時適度調整年費。

#### 試用期 - 7 天免費，

<div class="fee-warning" >請確定對您有益才繳費。一旦繳費，無論任何原因，恕不退費。</div>

註冊手續很容易，您只需要輸入 Email（會成為您的永久帳號，不能更改）、密碼和少數基本資料（將來可以更改），
並確認您能夠收到 Email 之後，您就註冊好了，不需要繳費。
完成註冊了以後，您有 7
天的時間試用。請務必確定對您有幫助之後，再付年費，成為正式會員。

有關退費的問題，我預計不會有很多會員，相對於設定退費機制和會計流程，覺得太麻煩。所以，拜託您不要亂繳費，因為一旦繳費，無論任何原因，恕不退費。

#### 續約辦法

您可以隨時續約，延後到期日。到期日最長 3 年 1 個月（3 年加上 1 個月的緩衝期）。

有關續約機制，我的基本假設是您不想要續訂，因此，我也不會敲鑼打鼓地慫恿您續訂。
在訂戶目前會員到期的前二個月，當您在這裡習易的時候，就會看到系統開始提醒您：「您的帳號將在【X】天後過期，
需要續訂的話，請即時處理。」，系統將不會有額外的 email 提醒您。

這裡也沒有自動續訂的選項。根據我的經驗，大部分的人都會忘記自己曾經選擇自動續約，
這種功能主要是以「給客戶方便」之名，創造業者額外收益，我覺得是不義之財。

您如果想要、需要續訂，每一次，您都該想想，值不值得？想清楚了再續訂。這樣子，我收您的錢也就心安理得，兩不相欠。
您要是二個月（60 天）都不在這裡起卦、解卦、習易，這表示您要嘛是太忙、要嘛不再需要這個工具，自然您就看不到系統提醒您的訊息，
那麼，我謝謝您之前的支持，您還是不要續訂了吧。

#### 為什麼要收費？

很簡單，所有的事務、活動，都有成本。使用者付費。

這個世界上，從來沒有免費的東西。
大公司讓您免費使用的服務，之所以免費，是因為您使用那些免費服務的行為本身就是那些大公司的「產品」，您用得多，他們賺得就多。

有些人、包括我在內，有時候繳了錢都不見得會好好利用買來的服務。於是我堅信：不交錢，沒付出，不心痛，就不會用功。
換句話說，是您花點錢來試著鞭策自己習易。而我，也不想用垃圾價來吸引會員，那樣不但沒意思，也是不義之財。

願意繳交會費這個事情的本身，也能夠大致確定參加的人都是有心習易的朋友，這樣一來，將來的溝通也比較方便。

{:else }

### 会员和费用

#### 加入会员有什么好处？

- 您可以使用所有的会员功能：读经、玩卦、起卦、纪录卦例、等等。
- 您可以随时续订，您还最多可以订 3 年的长约：您可能会想：「这算哪门子的好处？」从我的角度来看，这个世界上会想学易经的人本就不多，愿意花力气练习的人就更少了。所以，我其实不知道会有多少人参加、也不知道会给自己带来什么麻烦。如果过了一阵子，我发现坏处大于好处，我就可以把付费功能移除，等所有会员到期后就收摊。不过，只要有付费会员，我就有义务继续经营【XiYi 习易网】。所以，您要是觉得【XiYi 习易网】对您很有价值，您可以订个 3 年长约，强迫我至少再经营 3 年。会员期中，如果会员年费涨价了，和您无关；如果年费降了，我会按照比例将您的剩余期效延长，反正不会让您吃亏。

#### 年费

先讲好了，易经不好学，您要是用功学，应该就会感受到【XiYi
习易网】给您的帮助（省时省力），交点费用也就天经地义、顺理成章了。还有，本站没有月付会员制度，你如果还只是好奇、或是打算只学几个月，那就先不要加入交年费。

##### 一般会员：年费 USD$60。

相当每个月 USD$5，就当作您每个月请我喝一杯星巴克大拿铁吧。想想看，您一周花多少时间学习易经呢？您要是越用功、或是您的时间越宝贵，【XiYi
习易网】就能为您提供更大的价值。

##### 学生会员：3 年会费 USD$60。

只要您还是个是全职学生、生活所费仍然要靠父母提供，您可以缴交 USD$60，加入成为学生会员，换得 3 年在【XiYi
习易网】习易的环境。

成为学生会员的手续很简单：先注册。在订购/增购付款流程里，记得点选【学生会员】，
并且照实填写您学校的相关资料，最后缴交 3 年的会费：USD$60。

如果您有特殊情况，手头太紧，连 K 歌、看电影的钱都没有，而又很想加入会员，
请点这个连结，<a href={getMailtoUrl()}>
完整填写 email 表格后</a>，记得一定要把您的经济情况写一写，再 email 给我。事情总是有解的。

##### 年费 USD$60 背后的道理

根据研究，想要学习、精通一门学问或是技艺，大概需要一万个小时的投入。如果一天投入三个小时，十年后正好约一万小时，
也许能有所成，「十年磨一剑」也就是如此。
习易通透需要多久呢？十年够吗？我不知道。不过，根据我自己的经验，习易从初学到入门，很大一部分的时间和力气都是花在把书本「翻来翻去」，一桌子的书
，翻到气馁、翻到后面就忘了前面，等等。其实，这也就是我设计【XiYi
习易网】的基本动力 - 实在是翻得糊涂了！

假设一个还算用功的现代人，平均一天读易、习易 30 分钟，一个月共习易 15 小时，一年是 180 小时。【XiYi
习易网】能为您省时省力，不但不再需要经常「翻来翻去」，也不需要总是摊了一桌子的书，而且，随时随地用您的手机、平板都可以习易，这么一来，
我相信【XiYi 习易网】至少能够提升总体效率 30%。也就是一年为您节省了 60 个小时以上。

台湾现在最低工资时薪是台币 160，或约 USD$5。即使您的收入是最低工资，【XiYi
习易网】一年也至少能为您节省 USD$300 或是 NT$9000。您的收入是最低工资吗？您要是越用功、或是时间越宝贵，【XiYi
习易网】就能为您提供更大的价值。

如果您位是普通用功的人，每天平均只能花 10 分钟读易、学易，您的收入又是最低工资，
这样的话，年费和省下的钱大概还是比打平好一点，您省了力气，也提升了的习易的效率，一样很有好处。
不过，如果您要是平均一天真的只能最多花 10 分钟学易，也许出门去散步、跑步 10 分钟会对您更有益处！

为什么用美元计价呢？因为我现在住在美国。如果将来搬家，我也许再改当地货币。还有，接下来，我还打算增加更多功能、改善 UI、等等。
随著本站功能提升和可能的通货膨胀、货币贬值，所以，将来也会适时适度调整年费。

#### 试用期 - 7 天免费，

<div class="fee-warning" >请确定对您有益才缴费。一旦缴费，无论任何原因，恕不退费。</div>

注册手续很容易，您只需要输入 Email（会成为您的永久帐号，不能更改）、密码和少数基本资料（将来可以更改），
并确认您能够收到 Email 之后，您就注册好了，不需要缴费。
完成注册了以后，您有 7
天的时间试用。请务必确定对您有帮助之后，再付年费，成为正式会员。

有关退费的问题，我预计不会有很多会员，相对于设定退费机制和会计流程，觉得太麻烦。所以，拜托您不要乱缴费，因为一旦缴费，无论任何原因，恕不退费。

#### 续约办法

您可以随时续约，延后到期日。到期日最长 3 年 1 个月（3 年加上 1 个月的缓冲期）。

有关续约机制，我的基本假设是您不想要续订，因此，我也不会敲锣打鼓地怂恿您续订。
在订户目前会员到期的前二个月，当您在这里习易的时候，就会看到系统开始提醒您：「您的帐号将在【X】天后过期，
需要续订的话，请即时处理。」，系统将不会有额外的 email 提醒您。

这里也没有自动续订的选项。根据我的经验，大部分的人都会忘记自己曾经选择自动续约，
这种功能主要是以「给客户方便」之名，创造业者额外收益，我觉得是不义之财。

您如果想要、需要续订，每一次，您都该想想，值不值得？想清楚了再续订。这样子，我收您的钱也就心安理得，两不相欠。
您要是二个月（60 天）都不在这里起卦、解卦、习易，这表示您要嘛是太忙、要嘛不再需要这个工具，自然您就看不到系统提醒您的讯息，
那么，我谢谢您之前的支持，您还是不要续订了吧。

#### 为什么要收费？

很简单，所有的事务、活动，都有成本。使用者付费。

这个世界上，从来没有免费的东西。
大公司让您免费使用的服务，之所以免费，是因为您使用那些免费服务的行为本身就是那些大公司的「产品」，您用得多，他们赚得就多。

有些人、包括我在内，有时候缴了钱都不见得会好好利用买来的服务。于是我坚信：不交钱，没付出，不心痛，就不会用功。
换句话说，是您花点钱来试著鞭策自己习易。而我，也不想用垃圾价来吸引会员，那样不但没意思，也是不义之财。

愿意缴交会费这个事情的本身，也能够大致确定参加的人都是有心习易的朋友，这样一来，将来的沟通也比较方便。

{/if}

<style>
p {
font-size: 16px;
}
li {
font-size: 16px;
}
ul li {
margin-left: 40px;
list-style-type: square !important;
}
.yao-stat {
width: 100%;
}
.fee-warning{
    color:red; 
    font-size: 20px; 
    font-weight: 500;
}
</style>
